import { provideTransloco, translocoConfig, TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

@NgModule({
    exports  : [
        TranslocoModule
    ],
    providers: [
        // Configuração e loader (provideTransloco regista também transpiler, missing handler,
        // interceptor e fallback por omissão — o TranslocoService 8 exige-os)
        provideTransloco({
            config: translocoConfig({
                availableLangs      : [
                    {
                        id   : 'en',
                        label: 'English'
                    },
                    {
                        id   : 'tr',
                        label: 'Turkish'
                    }
                ],
                defaultLang         : 'en',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : true
            }),
            loader: TranslocoHttpLoader
        }),

        // Preload the default language before the app starts to prevent empty/jumping content
        provideAppInitializer(() =>
        {
            const translocoService = inject(TranslocoService);
            const defaultLang = translocoService.getDefaultLang();
            translocoService.setActiveLang(defaultLang);
            return firstValueFrom(translocoService.load(defaultLang));
        })
    ]
})
export class TranslocoCoreModule
{
}
